import React, { createContext, useCallback, useContext, useState } from "react";

interface IFilterContext {
  changeFilter: (value: any) => void;
  filters: any;
  resetFilters?: () => void;
}

const FilterContext = createContext<IFilterContext>({
  changeFilter: () => {},
  filters: null,
  resetFilters: () => {},
});

export const useFilterContext = () => useContext(FilterContext);

const FilterProvider: React.FC = ({ children }) => {
  const [filters, setFilter] = useState<any>();
  const changeFilter = (value: any) => {
    setFilter(value);
  };
  const resetFilters = useCallback(() => {
    setFilter(null);
  },[]);

  return (
    <FilterContext.Provider value={{ changeFilter, filters, resetFilters }}>
      {children}
    </FilterContext.Provider>
  );
};

export { FilterProvider, FilterContext };
